import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { UserProvider } from './context/UserContext';

import Login from './pages/login';
import Dashboard from './pages/Dashboard';
import ForgotPassword from './pages/ForgotPassword';
import AdminLayout from './layouts/AdminLayout';
import MyProfile from './pages/MyProfile';
import ChangePassword from './pages/ChangePassword';
import Languages from './pages/Languages';
import Roles from './pages/Roles';
import RolesPermissions from './pages/RolesPermissions';
import Organizations from './pages/Organizations';
import Users from './pages/Users';
import PrayerCategories from './pages/PrayerCategory';
import PublicPrayers from './pages/PublicPrayers';
import PrivatePrayers from './pages/PrivatePrayers';
import Testimonies from './pages/Testimonies';
import Events from './pages/Events';
import DailyDevotions from './pages/DailyDevotion';
import Drivers from './pages/Drivers';
import Feedback from './pages/Feedback';
import UserActivity from './pages/UserActivity';

import SpecialPrayerCategoryList from './pages/SpecialPrayerCategory';
import SpecialPrayers from './pages/SpecialPrayers';
import PrayerCloset from './pages/PrayerCloset';
import AddSpecialPrayer from './pages/AddSpecialPrayer';
import EditSpecialPrayer from './pages/EditSpecialPrayer';
import Subscribers from './pages/Subscribers';

import Songs from './pages/Songs';
import AddSong from './pages/AddSong';
import EditSong from './pages/EditSong';
import Settings from './pages/Settings';
import PdfSongs from './pages/PdfSongs';
import ViewPrayForTheNation from './pages/ViewPrayeTheNation';
import RegistrationForm from './pages/RegistrationForm';
import ActivateAccount from './pages/UseractivateAccount';
import Notifications from './pages/Notifications';

import GiverItems from './pages/GiverItems';
import GiverItemRequests from './pages/GiverItemRequests';
import NewItemRequests from './pages/NewItemRequests';
import GenerosityTestimonies from './pages/GenerosityTestimonies';
import InactiveUsers from './pages/InactiveUsers';
import Groups from './pages/Groups';

import RideConnect from './pages/RideConnect';
import ShareAndAccept from './pages/ShareAndAccept';
import PrayersHub from './pages/PrayersHub';
import ApprovalCenter from './pages/ApprovalCenter';

import AdminAgreement from './pages/AdminAgreement';
import TermsAndConditions from './pages/TermsAndConditions';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Guide from './pages/Guide';

// PrivateRoute implementation
function PrivateRoute({ children }) {
  const queryAuth = new URLSearchParams(window.location.search).get('auth');
  if (queryAuth === 'demo') {
    if (!localStorage.getItem('token')) {
      localStorage.setItem('token', 'gpn_demo_super_admin_token');
      localStorage.setItem('userInfo', JSON.stringify({
        id: 1,
        name: 'Super Admin',
        email: 'admin@glocalprayer.net',
        role: 1,
        role_name: 'Super Admin',
        organization: 'Glocal Prayer Network'
      }));
    }
    return children;
  }
  const token = localStorage.getItem('token');
  return token ? children : <Navigate to="/login" />;
}



function App() {
  return (
    <UserProvider>
      <Router>
        <Routes>
          {/* Public routes */}
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="appuserregistration/:id" element={<RegistrationForm />} />
          <Route path="userregistration/:id" element={<RegistrationForm />} />
          <Route path="activate/:id" element={<ActivateAccount />} />
          {/* Protected admin routes */}
          <Route path="/admin" element={
            <PrivateRoute>
              <AdminLayout />
            </PrivateRoute>
          }>
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="my-profile" element={<MyProfile />} />
            <Route path="change-password" element={<ChangePassword />} />
            <Route path="languages" element={<Languages />} />
            <Route path="roles" element={<Roles />} />
            <Route path="roles-permissions" element={<RolesPermissions />} />
            <Route path="organizations" element={<Organizations />} />
            <Route path="users" element={<Users />} />
            <Route path="approval-center" element={<Navigate to="/admin/prayers?tab=approvals" replace />} />
            <Route path="user-activity" element={<Navigate to="/admin/users" replace />} />
            
            {/* Prayers Hub & Aliases */}
            <Route path="prayers" element={<PrayersHub />} />
            <Route path="public-prayers" element={<PrayersHub initialTab="public" />} />
            <Route path="private-prayers" element={<PrayersHub initialTab="private" />} />
            <Route path="prayer-categories" element={<PrayersHub initialTab="categories" />} />
            
            <Route path="testimonies" element={<Testimonies />} />
            <Route path="events" element={<Events />} />
            <Route path="daily-devotions" element={<DailyDevotions />} />
            
            {/* Ride Connect Hub & Aliases */}
            <Route path="ride-connect" element={<RideConnect />} />
            <Route path="drivers" element={<RideConnect />} />
            
            <Route path="feedback" element={<Feedback />} />
            
            {/* Prayer Closet Hub & Aliases */}
            <Route path="prayer-closet" element={<PrayerCloset />} />
            <Route path="special-prayer-categories" element={<PrayerCloset initialTab="categories" />} />
            <Route path="special-prayers" element={<PrayerCloset initialTab="prayers" />} />
            <Route path="add-special-prayer" element={<AddSpecialPrayer />} />
            <Route path="edit-special-prayer/:id" element={<EditSpecialPrayer />} />
            <Route path="subscribers" element={<PrayerCloset initialTab="subscribers" />} />
            <Route path="chain-prayer" element={<Navigate to="/admin/prayer-closet" replace />} />
            
            {/* Share & Accept Hub & Aliases */}
            <Route path="share-and-accept" element={<ShareAndAccept />} />
            <Route path="giver-items" element={<ShareAndAccept />} />
            <Route path="giver-item-requests" element={<ShareAndAccept />} />
            <Route path="new-item-requests" element={<ShareAndAccept />} />
            <Route path="generosity-testimonies" element={<ShareAndAccept />} />
            
            {/* Songs */}
            <Route path="songs" element={<Songs />} />
            <Route path="add-song" element={<AddSong />} />
            <Route path="edit-song/:id" element={<EditSong />} />
            <Route path="pdf-songs" element={<PdfSongs />} />
            
            <Route path="settings" element={<Settings />} />
            <Route path="view-pray-for-nation" element={<ViewPrayForTheNation />} />
            <Route path="notifications" element={<Notifications />} />
            <Route path="inactive-users" element={<InactiveUsers />} />
            <Route path="groups" element={<Groups />} />
            
            {/* Admin Agreement, Legal & Help Guide routes */}
            <Route path="admin-agreement" element={<AdminAgreement />} />
            <Route path="terms-and-conditions" element={<TermsAndConditions />} />
            <Route path="privacy-policy" element={<PrivacyPolicy />} />
            <Route path="guide" element={<Guide />} />
          </Route>

          {/* Public Legal & Guide routes */}
          <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/guide" element={<Guide />} />

          {/* Default route redirect */}
          <Route path="*" element={<Navigate to="/login" />} />
        </Routes>
      </Router>
    </UserProvider>
  );
}

export default App;
